/**
 * Light mode semantic color tokens — Instagram light theme.
 */
const lightTokens = {
  "bg-app":         { default: "#FAFAFA" },
  "bg-surface":     { default: "#FFFFFF" },
  "bg-elevated":    { default: "#F0F0F0" },
  "bg-input":       { default: "#EFEFEF" },
  "border-subtle":  { default: "#DBDBDB" },
  "border-strong":  { default: "#B2B2B2" },
  "text-primary":   { default: "#262626" },
  "text-secondary": { default: "#8E8E8E" },
  "text-disabled":  { default: "#C7C7C7" },
  "accent":         { default: "#E1306C" },
  "accent-hover":   { default: "#C1275C" },
  "bubble-sent":    { default: "#EFEFEF" },
  "bubble-received":{ default: "#FFFFFF" },
  "online":         { default: "#22C55E" },
};

export default lightTokens;
